import useQuery from 'hooks/useQuery';
import useSearchWords from 'hooks/useSearchWords';

export interface CompanyNumberProps {
  searchWords?: string[];
}

export default function useCompanyNumberProps(): CompanyNumberProps {
  const [query] = useQuery('companies');

  const searchWords = useSearchWords(query);

  return {
    searchWords,
  };
}
